export default __webpack_public_path__ + "static/media/Clientes_Formato_de_facturas.7a6f30ac.xlsx";